import { getApi, postApi , putApi , deleteApi } from "../api";
import { postApiNew } from "../apiNew";

export const loginApi = (data) => postApi(`/auth/login`, data);

// Request OTP API
export const sendLoginOtpApi = (data) => postApiNew(`/auth/login-otp`, data);

// Verify OTP & login API
export const verifyLoginOtpApi = (data) => postApiNew(`/auth/verify-login-otp`, data);